module.exports = __webpack_public_path__ + "img/zhuanli1.466a56b3.png";